window.addEventListener('DOMContentLoaded', () => {
  $(document).on("ajax:success", '[data-application-id]', function(event) {
    let applicationId = this.dataset.applicationId;
    if (window.TableTyrant) {
      TableTyrant.Grid.withID('applications').updateRows([applicationId], {animate: true});
      TableTyrant.Grid.withID('all-applications').updateRows([applicationId], {animate: true});
    }
  });
});
